/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { getRobots, updateRobots } from '../../../redux/methods/seo';
import ContainerWithCard from '../../../components/ContainerWithCard';
import SectionEditFormButtons from '../../../components/SectionEditFormButtons';
import FormFieldCodeMirror from '../../../components/formFields/FormFieldCodeMirror';
import { Container, Form } from 'reactstrap';
import { Form as FinalForm } from 'react-final-form';
import useFetch from '../../../hooks/useFetch';
import styles from './index.module.scss';

const propTypes =
{
    getRobots: PropTypes.func,
    updateRobots: PropTypes.func
};

const defaultTemplate = `User-agent: *
Allow: /
Sitemap: {BaseUrl}/sitemap.xml`;

const Robots = ({ getRobots, updateRobots }) =>
{
    const intl = useIntl();
    const translations = intl.messages.seo.robots;
    const [data] = useFetch(getRobots);
    const handleReset = form =>
    {
        if (data) { form.reset({ ...data, template: defaultTemplate }); }
    };
    const additionalButtons = form =>
    [
        { title: 'Przywróć wartość domyślną', iconClass: 'fa fa-undo', onClick: () => handleReset(form) }
    ];
    return data ? (
        <ContainerWithCard title={translations.title} iconClass='fa fa-robot'>
            <FinalForm
                keepDirtyOnReinitialize
                initialValues={data}
                onSubmit={updateRobots}
                render={({ handleSubmit, form }) => {
                    return (
                        <Form onSubmit={handleSubmit}>
                            <Container fluid className='p-0'>
                                <div className='mt-3'>
                                    <FormFieldCodeMirror
                                        className={styles.textareaContainer}
                                        inputClassName={styles.textarea}
                                        label={translations.content}
                                        name='template'
                                        options={{
                                            mode: 'htmlmixed',
                                            theme: 'material',
                                            lineNumbers: true
                                        }}                                      
                                    />
                                </div>
                                <SectionEditFormButtons formReset={form.reset} additionalButtons={additionalButtons(form)} />
                            </Container>
                        </Form>
                    );
                }}
            />
        </ContainerWithCard>
    ) : <ContainerWithCard title={translations.title} iconClass='fa fa-robot'/>;
};

Robots.propTypes = propTypes;

const mapDispatch =
{
    getRobots,
    updateRobots
};

export default connect(null, mapDispatch)(Robots);